import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "./AppOptionsDialog.scss";
//import { useTranslation } from "react-i18next";
//import i18n from "i18next";
import PerfectScrollbar from "react-perfect-scrollbar";
import SessionCategorization from "../sessions/SessionCategorization";
import HandCategorization from "../hands/HandCategorization";
import { sendCommand } from "../components/Bridge";

function AppOptionsDialog() {

    const [show, setShow] = useState(false);
    const [actionName, setActionName] = useState("session-category-management");

    //const { t } = useTranslation();

    const showOptions = (actionName) => {
        setShow(true);
        setActionName(actionName);
    }

    window.toggleOptions = (actionName)=>{
        if(!show){
            setActionName(actionName);
        }
        setShow(!show);
    };

    useEffect(() => {
        return () => {
            console.debug("OptionsDialog effect done");
        };
    }, []);

    return (
        <>
            <Modal
                centered
                backdrop="static"
                show={show}
                dialogClassName="app-options-dialog"
                onHide={() => { }}
            >
                <Modal.Header>
                    <Modal.Title>
                        <Button
                            onClick={() => {
                                setShow(false);
                                sendCommand("gui/login/hideOptions");
                            }}
                        >
                            X<span>ESC</span>
                        </Button>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="dialog-content">
                        <div className="navigation-container">
                            <PerfectScrollbar className="navigation">
                                <div className="menu">Mon compte</div>
                                <div className="menuitem">Abonnement</div>
                                <div className="menuitem">Opencards</div>
                                <div className="menuitem">Forum</div>

                                <div className="menu">Import</div>
                                <div className={"menuitem" + (actionName === "sites-config" ? " active" : "")} onClick={() => showOptions("sites-config")}>Configuration des sites</div>
                                <div className={"menuitem" + (actionName === "import-options" ? " active" : "")} onClick={() => showOptions("import-options")}>Options d'import</div>

                                <div className="menu">Catégorisation</div>
                                <div className={"menuitem" + (actionName === "player-category-management" ? " active" : "")} onClick={() => showOptions("player-category-management")}>Joueurs</div>
                                <div className={"menuitem" + (actionName === "session-category-management" ? " active" : "")} onClick={() => showOptions("session-category-management")}>Sessions</div>
                                <div className={"menuitem" + (actionName === "hand-category-management" ? " active" : "")} onClick={() => showOptions("hand-category-management")}>Mains</div>

                                <div className="menu">Limites de jeu</div>
                                <div className={"menuitem" + (actionName === "limits-mtt" ? " active" : "")} onClick={() => showOptions("limits-mtt")}>Tournois</div>
                                <div className={"menuitem" + (actionName === "limits-cash" ? " active" : "")} onClick={() => showOptions("limits-cash")}>Cashgame</div>

                                <div className="menu">Options</div>
                                <div className="menuitem">Mes pseudos</div>
                                <div className="menuitem">Autres</div>
                            </PerfectScrollbar>
                        </div>
                        <PerfectScrollbar className="content-container">
                            <div className="content">
                                {actionName === "session-category-management" ? <SessionCategorization></SessionCategorization> : <></>}
                                {actionName === "hand-category-management" ? <HandCategorization></HandCategorization> : <></>}
                            </div>
                        </PerfectScrollbar>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
export default AppOptionsDialog;
